import { Directive, inject } from '@angular/core';

import { CandidateAnalytics } from '@core/candidate-util';

@Directive({
  selector: '[rtCandidateDataVisibilityAnalytics]',
  standalone: true,
  host: {
    '(toggleDataVisibility)': 'onToggleDataVisibility($event)',
  },
})
export class CandidateDataVisibilityAnalyticsDirective {
  private readonly candidateAnalytics = inject(CandidateAnalytics);

  public onToggleDataVisibility(shouldBeVisible: boolean | Event): void {
    if (!shouldBeVisible) {
      return;
    }

    this.candidateAnalytics.trackReveal();
  }
}
